/**
 * @file DesignSwatches.tsx
 * @description Образец дизайна (phase19.16 Р1-6а; решения 2026-10-12):
 * плитка «Аа» шрифтом заголовков на фоне страницы и пять кружков цветов
 * ролей. Общий для карточки дизайна и списка «Какого» в окне создания.
 */

import type { SiteDesignSummary } from "@chaiberi/shared";

import { cn } from "@/lib/utils";

/** Пять цветов ролей в порядке образца. */
function swatchColors({ colors }: SiteDesignSummary): string[] {
  return [colors.pageBg, colors.text, colors.button, colors.accent, colors.darkBg];
}

interface TileProps {
  summary: SiteDesignSummary;
  /** `md` — карточка (48×80), `sm` — строка списка (40×56). */
  size?: "sm" | "md";
}

/** Плитка «Аа»: фон страницы, цвет текста, шрифт заголовков. */
export function DesignFontTile({ summary, size = "md" }: TileProps) {
  return (
    <div
      aria-hidden
      className={cn("flex shrink-0 items-center justify-center rounded-lg", size === "md" ? "h-12 w-20" : "h-10 w-14")}
      style={{ background: summary.colors.pageBg, color: summary.colors.text, boxShadow: "inset 0 0 0 1px var(--border)" }}
    >
      <span className={size === "md" ? "text-xl" : "text-base"} style={{ fontFamily: `"${summary.fonts.heading}", serif` }}>
        Аа
      </span>
    </div>
  );
}

interface DotsProps {
  summary: SiteDesignSummary;
  /** `md` — 24px (карточка), `sm` — 16px (строка списка). */
  size?: "sm" | "md";
  className?: string;
}

/** Пять кружков цветов; для скринридера — одна подпись. */
export function DesignColorDots({ summary, size = "md", className }: DotsProps) {
  return (
    <span role="img" aria-label="Цвета дизайна" className={cn("flex shrink-0 items-center gap-1", className)}>
      {swatchColors(summary).map((color, i) => (
        <span
          key={`${color}-${i}`}
          className={cn("rounded-full [box-shadow:inset_0_0_0_1px_var(--border)]", size === "md" ? "size-6" : "size-4")}
          style={{ background: color }}
        />
      ))}
    </span>
  );
}
